import { create } from 'zustand';

interface SupportState {
  /** Whether the "How can we help?" sheet is showing. */
  open: boolean;
}

interface SupportActions {
  openSupport: () => void;
  closeSupport: () => void;
  setSupportOpen: (open: boolean) => void;
}

/**
 * UNPERSISTED, single-purpose store for the support sheet's open state
 * (GIFTWEB-32).
 *
 * The sheet is owned by `NeedHelp`, but the things that open it are scattered:
 * the pill and the allowance sheet, which sits inside `InfoSheet`. (A "Get
 * support" tile on the amount step was a third until GIFTWEB-39 removed it.)
 * A store rather than a context because the openers are not all descendants of
 * one obvious provider, and because a missing provider would fail at runtime in
 * exactly the place a contributor is asking for help.
 */
const useSupportStore = create<SupportState & SupportActions>()((set) => ({
  open: false,
  openSupport: () => set({ open: true }),
  closeSupport: () => set({ open: false }),
  setSupportOpen: (open: boolean) => set({ open }),
}));

export const useSupportOpen = () => useSupportStore((s) => s.open);
export const useOpenSupport = () => useSupportStore((s) => s.openSupport);
export const useCloseSupport = () => useSupportStore((s) => s.closeSupport);
export const useSetSupportOpen = () => useSupportStore((s) => s.setSupportOpen);

export default useSupportStore;
